// A qué sección del producto lleva lo que devolvió una consulta.
//
// **Aquí sí se mira el nombre de la herramienta**, al revés que en `formas.ts`,
// y la diferencia está razonada: pintar por nombre haría que una capacidad
// nueva no se viera hasta añadirla a mano, que es un fallo silencioso. Enlazar
// por nombre degrada bien: una herramienta que no esté en esta tabla
// simplemente no enseña enlace, y lo que devolvió se ve igual.
//
// Enlazar es lo único que R10 de `brain-agente-maestro` permite: el Brain
// responde, ejecuta y **enlaza**, pero no abre modales ni lleva al usuario por
// la pantalla.

/** Fragmento del nombre de la herramienta -> ruta, sin el prefijo de idioma. */
const SECCIONES: Array<[RegExp, { ruta: string; clave: string }]> = [
  [/_agents_agent_id_connections/, { ruta: 'channel-agents', clave: 'brain.ver_en_conexiones' }],
  [/_agents_agent_id_tools/, { ruta: 'agents', clave: 'brain.ver_en_agentes' }],
  [/_agents/, { ruta: 'agents', clave: 'brain.ver_en_agentes' }],
  [/_tools/, { ruta: 'tools', clave: 'brain.ver_en_herramientas' }],
  [/_documents/, { ruta: 'knowledge', clave: 'brain.ver_en_conocimiento' }],
]

export function seccionDe(nombreDeHerramienta: string): { ruta: string; clave: string } | null {
  for (const [patron, destino] of SECCIONES) {
    if (patron.test(nombreDeHerramienta)) return destino
  }
  return null
}
